import Vue from 'vue'
import Router from 'vue-router'
import NotFond from '../views/404.vue'
import Login from '../views/login.vue'
import Home from '../views/Home.vue'
import Index from '../views/index.vue';
import user from '../views/system/user';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      name:'Login',
      component:Login
    },
    {
      path: '/index',
      name: 'Home',
      component: Home
    }, {
      path: '/index',
      name: '首页',
      component: Index,
      iconCls: 'el-icon-tickets',
      children: [ {
          path: '/system/user',
          name: '用户管理',
          component: user,
          meta: {
              requireAuth: true
          }
      }, ]
      },
    {
      path: '*',
      name: '404',
      component: NotFond
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js